import React, { useEffect, useState } from "react";
import {
    useModalForm, Modal, Space, Form,
    Row,
    Col,
    Button,
    Input,
    Radio, Checkbox,
} from "@pankod/refine-antd";

export const ToggleVirtualAccountOptionsModel: React.FC<{ tableProps: any, setTableRefetch: any }> = ({ tableProps, setTableRefetch }) => {
    const { id, isPreferredForQuickPayUpi, isPreferredForQuickPayBankTransfer } = tableProps || {};
    const [preferredForQuickPayUpi, setPreferredForQuickPayUpi] = useState(isPreferredForQuickPayUpi);
    const [preferredForQuickPayBankTransfer, setPreferredForQuickPayBankTransfer] = useState(isPreferredForQuickPayBankTransfer);

    const { modalProps: bankOptionsModal, formProps: bankOptionsForm, show: bankOptionsShow, close: bankOptionsClose } = useModalForm<any>({
        action: "create",
        dataProviderName: "grapghQl",
        resource: "toggleVirtualAccountQuickPayPreferenceForBankAccount",
        metaData: {
            bankAccountId: id,
            isPreferredForQuickPayUpi: preferredForQuickPayUpi,
            isPreferredForQuickPayBankTransfer: preferredForQuickPayBankTransfer,
        },
        redirect: false,
        onMutationSuccess(response) {
            const result = response?.data;
            if (result?.success) {
                setTableRefetch(true);
            } else {
                throw new Error(result?.message || 'Failed to save');
            }
        }
    });

    bankOptionsModal.title = `Edit Virtual Quick Pay Options`;
    bankOptionsModal.centered = true;
    bankOptionsModal.width = 800;
    bankOptionsModal.onCancel = () => {
        bankOptionsForm.form?.resetFields();
        setPreferredForQuickPayUpi(isPreferredForQuickPayUpi);
        setPreferredForQuickPayBankTransfer(isPreferredForQuickPayBankTransfer)
        bankOptionsClose();
    }

    const togglePreferenceCheckbox = (value: boolean, type: string): void => {
        switch (type) {
            case "upi":
                setPreferredForQuickPayUpi(value)
                bankOptionsForm.form?.setFieldsValue({isPreferredForQuickPayUpi: value})
                break;
            case "bankTransfer":
                setPreferredForQuickPayBankTransfer(value);
                bankOptionsForm.form?.setFieldsValue({isPreferredForQuickPayBankTransfer: value})
                break;
            default:
                return;
        }
    }

    useEffect(() => {
        if (bankOptionsModal.visible && tableProps) {
            const {
                isPreferredForQuickPayUpi,
                isPreferredForQuickPayBankTransfer
            } = tableProps;

            togglePreferenceCheckbox(isPreferredForQuickPayUpi, 'upi');
            togglePreferenceCheckbox(isPreferredForQuickPayBankTransfer, 'bankTransfer');
        }
    }, [bankOptionsModal.visible, tableProps]);

    return (
        <Space>
            <Button className="credit-btn" type={'primary'} onClick={() => { bankOptionsShow() }}> Edit Bank Account Options</Button>

            <Modal {...bankOptionsModal}>
                <Form {...bankOptionsForm} initialValues={{ id }} layout="vertical">
                    <Row gutter={16}>
                        <Col lg={16}>
                            <Form.Item label="Id" name="id">
                                <Input disabled={true} value={id} />
                            </Form.Item>
                        </Col>
                    </Row>
                    <Row gutter={16}>
                        <Col lg={8}>
                            <Form.Item label="UPI" name="isPreferredForQuickPayUpi">
                                <Checkbox
                                    checked={preferredForQuickPayUpi}
                                    onChange={
                                        (e) => {
                                            togglePreferenceCheckbox(e.target.checked, 'upi');
                                        }
                                    }
                                />
                            </Form.Item>
                        </Col>
                        <Col lg={8}>
                            <Form.Item label="Bank Transfer" name="isPreferredForQuickPayBankTransfer">
                                <Checkbox
                                    checked={preferredForQuickPayBankTransfer}
                                    onChange={
                                        (e) => {
                                            togglePreferenceCheckbox(e.target.checked, 'bankTransfer');
                                        }
                                    }
                                />
                            </Form.Item>
                        </Col>
                    </Row>
                </Form>
            </Modal>
        </Space>
    );
};